module.exports = __webpack_public_path__ + "static/media/dots-background.3c26db2c.png";